<!--
 * @Author: xiaona.wang
 * @LastEditors: pingping.mao
 * @Date: 2021-08-12 18:58:32
 * @LastEditTime: 2023-02-07 16:38:51
 * @Description: 编码管理新增
-->
<template>
  <div class="common-form-wrap">
    <div class="common-form-title">
      <span class="common-form-title--text">{{ $t("public.basicInformation") }}</span>
      <div class="back themeGreen" @click="closeModel">
        <i class="el-icon-back" style="margin-right: 4px" /> 返回
      </div>
    </div>
    <div class="common-form-content">
      <el-form ref="baseFromRef" :model="formData" :rules="baseRules" label-position="top">
        <el-row :gutter="20">
          <!-- 编码代码 start -->
          <el-col :span="6">
            <el-form-item
              :label="$t('code.codeValue')"
              prop="code"
              label-width="120px"
              class="padding-right25"
            >
              <el-input
                v-model="formData.code"
                :disabled="operatetype == 'view'"
                placeholder="请输入编码代码"
                max-length="64"
              ></el-input>
            </el-form-item>
          </el-col>
          <!-- 编码代码 end -->
          <!-- 编码名称 start -->
          <el-col :span="6">
            <el-form-item
              :label="$t('code.codeName')"
              prop="name"
              label-width="120px"
              class="padding-right25"
            >
              <el-input
                v-model="formData.name"
                :disabled="operatetype == 'view'"
                placeholder="请输入编码名称"
                type="text"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
          <!-- 编码名称 end -->
          <!-- 绑定表 start -->
          <el-col :span="6">
            <el-form-item
              :label="$t('code.bindTable')"
              prop="tableName"
              label-width="120px"
              class="padding-right25"
            >
              <el-input
                v-model="formData.tableName"
                :disabled="operatetype == 'view'"
                placeholder="请输入绑定表"
                max-length="64"
              ></el-input>
            </el-form-item>
          </el-col>
          <!-- 绑定表 end -->
          <!-- 绑定字段 start -->
          <el-col :span="6">
            <el-form-item
              :label="$t('code.bindField')"
              prop="columnName"
              label-width="120px"
              class="padding-right25"
            >
              <el-input
                v-model="formData.columnName"
                :disabled="operatetype == 'view'"
                placeholder="请输入绑定字段"
                max-length="64"
              ></el-input>
            </el-form-item>
          </el-col>
          <!-- 绑定字段 end -->
        </el-row>
        <div class="common-form-title" style="margin-left: -172px">
          <span class="common-form-title--text">编码规则</span>
        </div>
        <!-- 根据动态数组渲染对编码规则内容 start -->
        <el-row
          v-for="(domain, index) in formData.autoCodeSegments"
          :key="domain.index"
          :gutter="20"
        >
          <el-col :span="5">
            <el-form-item
              :label="$t('code.codeSegmentType')"
              label-width="120px"
              class="padding-right25"
            >
              <el-select
                v-model="domain.segmentType"
                :prop="`autoCodeSegments.${index}.segmentType`"
                placeholder="请选择码段类型"
                :disabled="operatetype == 'view'"
                @change="changeCodeType(index, $event)"
              >
                <el-option
                  v-for="item in codeType"
                  :key="item.dictValue"
                  :label="item.dictLabel"
                  :value="item.dictValue"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 根据码段类型切换对应的第二列内容 start -->
          <el-col v-if="domain.segmentType == 'CONSTANT'" :span="6">
            <el-form-item
              :prop="`autoCodeSegments.${index}.segmentValue`"
              :label="$t('code.codeSegmentValue')"
              label-width="120px"
              class="padding-right25"
              :rules="{
                required: true,
                message: '不允许为空',
                trigger: 'blur'
              }"
            >
              <el-input
                v-model="domain.segmentValue"
                :disabled="operatetype == 'view'"
                placeholder="请输入码段值"
                type="text"
                max-length="16"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col v-if="domain.segmentType == 'STATEMENT'" :span="6">
            <el-form-item
              :label="$t('code.length')"
              :prop="`autoCodeSegments.${index}.segmentValue`"
              label-width="120px"
              class="padding-right25"
              :rules="{
                required: true,
                message: '不允许为空',
                trigger: 'blur'
              }"
            >
              <el-input-number
                v-model="domain.segmentValue"
                :precision="0"
                prop="'autoCodeSegments.' + index + '.segmentValue'"
                :disabled="operatetype == 'view'"
                placeholder="请输入长度"
                controls-position="right"
                :min="0"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col v-if="domain.segmentType == 'DATE'" :span="6">
            <el-form-item
              :label="$t('code.format')"
              :prop="`autoCodeSegments.${index}.segmentValue`"
              label-width="120px"
              class="padding-right25"
              :rules="{
                required: true,
                message: '不允许为空',
                trigger: 'change'
              }"
            >
              <el-select
                v-model="domain.segmentValue"
                :disabled="operatetype == 'view'"
                placeholder="请选择格式化"
              >
                <el-option
                  v-for="item in dataFormatter"
                  :key="item.dictValue"
                  :label="item.dictLabel"
                  :value="item.dictValue"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 根据码段类型切换对应的第二列内容 end -->
          <el-col :span="3">
            <el-form-item
              :label="$t('code.editable')"
              :prop="`autoCodeSegments.${index}.autoCodeEditPermission`"
              label-width="120px"
              class="padding-right25"
            >
              <el-select
                v-model="domain.autoCodeEditPermission"
                :disabled="domain.segmentType == 'CONSTANT' || operatetype == 'view'"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in isEdit"
                  :key="item.dictValue"
                  :label="item.dictLabel"
                  :value="item.dictValue"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 码段类型为流水码时自动增长列分为自动增长和自动补零 其他为走动增长 start -->
          <el-col v-if="domain.segmentType !== 'STATEMENT'" :span="5">
            <el-form-item
              :prop="`autoCodeSegments.${index}.autoIncrease`"
              :label="$t('code.selfGrowth')"
              label-width="120px"
              class="padding-right25"
            >
              <el-select
                v-model="domain.autoIncrease"
                :disabled="domain.segmentType == 'CONSTANT' || operatetype == 'view'"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in isIncrease"
                  :key="item.dictValue"
                  :label="item.dictLabel"
                  :value="item.dictValue"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col v-if="domain.segmentType == 'STATEMENT'" :span="2">
            <el-form-item
              :label="$t('code.selfGrowth')"
              :prop="`autoCodeSegments.${index}.autoIncrease`"
              label-width="120px"
              class="padding-right25"
            >
              <el-select
                v-model="domain.autoIncrease"
                :disabled="domain.segmentType == 'CONSTANT' || operatetype == 'view'"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in isIncrease"
                  :key="item.dictValue"
                  :label="item.dictLabel"
                  :value="item.dictValue"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col v-if="domain.segmentType == 'STATEMENT'" :span="3">
            <el-form-item
              :label="$t('code.autoZeroFill')"
              :prop="`autoCodeSegments.${index}.isZeroize`"
              label-width="120px"
              class="padding-right25"
            >
              <el-select
                v-model="domain.isZeroize"
                :disabled="operatetype == 'view'"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in isIncrease"
                  :key="item.dictValue"
                  :label="item.dictLabel"
                  :value="item.dictValue"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 码段类型为流水码时自动增长列分为自动增长和自动补零 其他为走动增长 end -->
          <el-col v-if="operatetype !== 'view'" :span="5">
            <el-form-item style="padding-top: 20px">
              <span
                :class="[
                  'circle-button',
                  'circle--delete',
                  {
                    'is-disabled': index == '0'
                  }
                ]"
                style="margin-right: 10px"
                :disabled="index == '0'"
                @click="deleteCode(index)"
              >
                <svg-icon icon-class="sort-del"></svg-icon>
              </span>
              <span
                class="circle-button circle--primary"
                style="margin-right: 10px"
                @click="addCode()"
              >
                <svg-icon icon-class="sort-add"></svg-icon>
              </span>

              <span
                :class="[
                  'circle-button',
                  'circle--primary',
                  {
                    'is-disabled': index == '0'
                  }
                ]"
                style="margin-right: 10px"
                :disabled="index == '0'"
                @click="upCode(index)"
              >
                <svg-icon icon-class="sort-up"></svg-icon>
              </span>
              <span
                :class="[
                  'circle-button',
                  'circle--primary',
                  {
                    'is-disabled': index == Number(formData.autoCodeSegments.length) - 1
                  }
                ]"
                style="margin-right: 10px"
                :disabled="index === Number(formData.autoCodeSegments.length) - 1"
                @click="downCode(index)"
              >
                <svg-icon icon-class="sort-down"></svg-icon>
              </span>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 根据动态数组渲染对编码规则内容 end -->
        <!-- 按钮组  -->
        <div v-if="operatetype !== 'view'" class="excel-label-btn">
          <!-- <el-form :inline="true" class="demo-form-inline" @submit.native.prevent> -->
          <el-form-item class="float-right" style="margin-right: 0">
            <!-- 预览按钮 -->
            <el-button class="back-btn" type="primary" @click="preview()">预览</el-button>
            <!-- 保存按钮 -->
            <el-button class="save-btn" type="primary" @click="save()">
              {{ $t("public.save") }}
            </el-button>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <!-- 预览弹框 start -->
    <preview :visible.sync="previewDialogVisible" :previews="previewData"></preview>
    <!-- 预览弹框 end -->
  </div>
</template>

<script>
import { getDictionary } from "@/api/common";
import codeApi from "@/api/code/code";
import Preview from "./preview.vue";
import Role from "@/api/role/role";
import { formatDate } from "@/utils/date.js";
export default {
  name: "CodeAddEdit",
  components: {
    Preview
  },
  props: {
    type: {
      type: String,
      default: "add"
    },
    dataId: {
      type: [String, Object],
      default: null
    }
  },
  data() {
    return {
      codeType: [],
      isEdit: [],
      isIncrease: [
        { dictLabel: "是", dictValue: true },
        { dictLabel: "否", dictValue: false }
      ],
      dataFormatter: [],
      operatetype: "add",
      formData: {
        code: "",
        name: "",
        tableName: "",
        columnName: "",
        autoCodeSegments: [
          {
            segmentType: "CONSTANT",
            autoCodeEditPermission: "READ_ONLY",
            autoIncrease: false,
            segmentValue: ""
          }
        ]
      },
      // 基本信息校验
      baseRules: {
        code: [
          {
            required: true,
            message: `请输入编码代码`,
            trigger: "blur"
          }
        ],
        name: [
          {
            required: true,
            message: `请输入编码名称`,
            trigger: "blur"
          }
        ]
      },
      previewData: [],
      previewDialogVisible: false,
    };
  },
  created() {
    // 1.获取码段类型字典 2.获取可编辑字典 3.获取是否自增长字典4.获取日期格式字典
    this.getCodeType();
    this.getIsEdit();
    this.getDateFormatter();
    this.operatetype = this.type;

    this.getDetail();
  },
  methods: {
    addCode() {
      this.formData.autoCodeSegments.push({
        segmentType: "CONSTANT",
        autoCodeEditPermission: "READ_ONLY",
        autoIncrease: false,
        segmentValue: ""
      });
    },
    deleteCode(index) {
      if (index === 0) {
        return;
      }
      for (let i = 0; i < this.formData.autoCodeSegments.length; i++) {
        if (i === index) {
          this.formData.autoCodeSegments.splice(i, 1);
        }
      }
    },
    changeCodeType(index, event) {
      // 如果是日期编码
      this.formData.autoCodeSegments[index].segmentValue = "";
      switch (event) {
        case "DATE":
          this.formData.autoCodeSegments[index].segmentType = "DATE";
          this.formData.autoCodeSegments[index].autoCodeEditPermission = "EDITABLE";
          this.formData.autoCodeSegments[index].autoIncrease = false;
          break;
        case "STATEMENT":
          this.formData.autoCodeSegments[index].segmentType = "STATEMENT";
          this.formData.autoCodeSegments[index].autoCodeEditPermission = "READ_ONLY";
          this.formData.autoCodeSegments[index].autoIncrease = true;
          this.formData.autoCodeSegments[index].isZeroize = true;
          this.formData.autoCodeSegments[index].defaultValue = "1";
          this.formData.autoCodeSegments[index].segmentValue = "1";
          break;
        default:
          this.formData.autoCodeSegments[index].segmentType = "CONSTANT";
          this.formData.autoCodeSegments[index].autoCodeEditPermission = "READ_ONLY";
          this.formData.autoCodeSegments[index].autoIncrease = false;
      }
    },
    upCode(index) {
      if (index === 0) {
        return;
      }
      const newDynamic = [...this.formData.autoCodeSegments];
      const temp = newDynamic[index];
      newDynamic[index] = newDynamic[index - 1];
      newDynamic[index - 1] = temp;
      this.$nextTick(() => {
        this.formData.autoCodeSegments = [...newDynamic];
      });
    },

    downCode(index) {
      if (index === this.formData.autoCodeSegments.length - 1) {
        return;
      }
      const newDynamic = [...this.formData.autoCodeSegments];
      const temp = newDynamic[index];
      newDynamic[index] = newDynamic[index + 1];
      newDynamic[index + 1] = temp;
      this.$nextTick(() => {
        this.formData.autoCodeSegments = [...newDynamic];
      });
    },
    closeModel() {
      this.$emit("back");
    },
    preview() {
      // 遍历数据，转换格式，展示在页面
      this.previewData = [];
      const previewData = [];
      for (let i = 0; i < this.formData.autoCodeSegments.length; i++) {
        const current = this.formData.autoCodeSegments[i];
        if (current.segmentType === "DATE") {
          // 日期转换
          const data = formatDate(new Date(), current.segmentValue);
          previewData.push({
            name: data,
            type: current.autoCodeEditPermission
          });
        }
        if (current.segmentType === "CONSTANT") {
          previewData.push({
            name: current.segmentValue,
            type: current.autoCodeEditPermission
          });
        }
        if (current.segmentType === "STATEMENT") {
          if (!current.isZeroize) {
            previewData.push({
              name: "1",
              type: current.autoCodeEditPermission
            });
          } else {
            let zero = "";
            for (let i = 1; i < current.segmentValue; i++) {
              zero += "0";
            }
            previewData.push({
              name: `${zero}1`,
              type: current.autoCodeEditPermission
            });
          }
        }
      }
      this.previewData = [...previewData];
      this.previewDialogVisible = true;
    },
    save() {
      const _this = this;
      _this.$refs.baseFromRef.validate(valid => {
        if (valid) {
          _this.loading = true;
          // 判断是否有一条流水码信息
          let flag = false;
          _this.formData.autoCodeSegments.forEach((item, index) => {
            if (item.segmentType === "STATEMENT") {
              flag = true;
            }
            item.segmentOrder = index;
          });
          if (!flag) {
            _this.$message.error("编码规则必须有一条流水码信息");
            return;
          }
          _this.formData.autoCodeSegments = [..._this.formData.autoCodeSegments];
          // 提交后台
          if (_this.operatetype === "add") {
            codeApi.addForm(_this.formData).then(res => {
              _this.successCallback(res, true);
            });
          } else if (_this.operatetype === "edit") {
            codeApi.editForm(_this.formData).then(res => {
              this.successCallback(res, false);
            });
          }
        }
      });
    },

    /**
     * @name: 接口成功调用
     * @test: test front
     * @msg:
     * @param {*} res 新增编辑接口返回值
     * @param {*} isAdd  true代表是新增成功 false 代表是编辑成功
     * @return {*}
     */
    successCallback(res, isAdd) {
      this.loading = false;
      if (res.data) {
        this.$message.success(this.$t(`${isAdd ? "common.addSuccess" : "common.editSuccess"}`));
        this.closeModel();
      }
    },
    getDetail() {
      const codeId = window.atob(this.dataId);
      if (this.dataId === "null") {
        const obj = {
          code: "",
          name: "",
          tableName: "",
          columnName: "",
          autoCodeSegments: [
            {
              segmentType: "CONSTANT",
              autoCodeEditPermission: "READ_ONLY",
              autoIncrease: false,
              segmentValue: ""
            }
          ]
        };
        this.formData = { ...obj };
      } else {
        codeApi.getDetailById({ id: codeId }).then(res => {
          const { data } = res;
          if (data) {
            this.formData = { ...data };
          }
        });
      }
    },
    // 获取码段类型字典
    getCodeType() {
      getDictionary(
        { code: "CODE_TYPE" },
      ).then(res => {
        if (res.success) {
          if (res.data && res.data.dictItems && res.data.dictItems.length) {
            this.codeType = res.data.dictItems;
          }
        }
      });
    },
    getIsEdit() {
      getDictionary({ code: "IS_EDIT" }).then(res => {
        if (res.success) {
          if (res.data && res.data.dictItems && res.data.dictItems.length) {
            this.isEdit = res.data.dictItems;
          }
        }
      });
    },
    getDateFormatter() {
      getDictionary({ code: "DATA-FORMATTER" }).then(res => {
        if (res.success) {
          if (res.data && res.data.dictItems && res.data.dictItems.length) {
            this.dataFormatter = res.data.dictItems;
          }
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.back {
  line-height: 20px;
  display: inline-block;
  margin-bottom: 3px;
  font-size: 14px;
  cursor: pointer;
}
.el-input-number {
  width: 100%;
}
.circle-button {
  display: inline-block;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  background: #fff;
  border: 1px solid #d4d9e2;
  border-radius: 50%;
  width: 18px;
  height: 18px;
  text-align: center;
  padding: 0px;
  color: #fff;
  background-color: #c6ccd7;
  border-color: #c6ccd7;
}
.is-disabled:hover {
  color: #c6ccd7;
  cursor: not-allowed;
  background-image: none;
  background-color: #fff;
  border-color: #d4d9e2;
}
.circle--primary:hover {
  background-color: #00b259;
  border-color: #00b259;
}
.circle--delete:hover {
  background-color: #e60000;
  border-color: #e60000;
}
.el-select {
  width: 100%;
}
</style>
